import { type SuperTokensConfig } from 'supertokens-web-js/lib/build/types';
import Passwordless from 'supertokens-web-js/recipe/passwordless';
import Session from 'supertokens-web-js/recipe/session';
import { getApiURL } from '../util/select-api';
import { getCookieHandler } from './cookieHandler';
import { getWindowHandler } from './windowHandler';

export const config: SuperTokensConfig = {
  appInfo: {
    apiDomain: getApiURL(),
    apiBasePath: '/auth',
    appName: 'Volumental Visa',
  },
  cookieHandler: getCookieHandler,
  windowHandler: getWindowHandler,
  recipeList: [
    Passwordless.init(),
    Session.init({
      isInIframe: true,
      tokenTransferMethod: 'header',
    }),
  ],
};
